// extracted by mini-css-extract-plugin
module.exports = {"Backstage":"backstage_Backstage__18TLp"};